import { ProfileListResult, type ProfileMeta, ProfileSummary } from '@apm/contracts';
import { toQuery } from '../api';
import { useQuery } from '../hooks/useQuery';

/**
 * CPU 기록 목록·상세 조회 (8회차 결정 4).
 *
 * 기록은 10분에 한 건 뜰까 말까 한 값이라 실시간으로 밀 이유가 없다. 화면에 들어올 때 한 번 읽고,
 * 목록은 새로고침으로 다시 읽는다.
 *
 * 19회차에 서비스·프로세스로 거르는 조건이 붙었다(후보 #2). 서버는 처음부터 받고 있었다.
 */

export interface ProfileListState {
  loading: boolean;
  rows: ProfileMeta[];
  error?: string;
  reload: () => void;
}

export function useProfileList(
  filter: { service?: string; instance?: string } = {},
): ProfileListState {
  const { service, instance } = filter;
  const { loading, data, error, reload } = useQuery(
    `/api/profiles${toQuery({ service, instance })}`,
    ProfileListResult,
  );
  return { loading, rows: data ?? [], error, reload };
}

export interface ProfileDetailState {
  loading: boolean;
  summary?: ProfileSummary;
  error?: string;
  /** `summary`가 앞 주소(다른 기록)의 답이다. 그리지 않는다 (44회차) */
  stale: boolean;
}

export function useProfileDetail(id: string): ProfileDetailState {
  const { loading, data, error, stale } = useQuery(`/api/profiles/${id}`, ProfileSummary);
  return { loading, summary: data, error, stale };
}
